import React from 'react';
import MessageDefinitions from '../i18n/MessageDefinitions';
import {FormattedMessage, FormattedRelative} from 'react-intl';
import FontAwesome from 'react-fontawesome';

const ViewNote =
  ({
     note,
     onEdit,
     onRemove
   }) => {
    const {
      content,
      timestamp,
      employee: {
        firstName,
        lastName
      }
    } = note;

    return <div className="card note">
      <div className="card-block">{content}</div>
      <div className="card-footer">
        <small className="text-muted">by {firstName} {lastName} - <FormattedRelative value={timestamp}/></small>
        <div className="btn-group actions">
          <button className="btn btn-link edit" onClick={() => onEdit(note)}><FontAwesome name="pencil"/></button>
          <button className="btn btn-link remove" onClick={() => onRemove(note)}><FontAwesome name="trash-o"/></button>
        </div>
      </div>
    </div>
  };

class EditNote extends React.Component {
  state = {
    content: this.props.note.content || ''
  };

  contentChanged = (event) => {
    this.setState({
      content: event.target.value
    });
  };

  save = () => {
    this.props.onSave(
      this.state.note,
      content
    );
  };

  render() {
    const {
      note,
      onCancel,
      onSave
    } = this.props;

    const {content} = this.state;

    return <div className="card note editing">
      <div className="card-block">
        <div className="card-title">
          <FormattedMessage {...MessageDefinitions.newNoteTitle}/>
        </div>
        <textarea rows="7" className="form-control" value={content} onChange={this.contentChanged}/>
      </div>
      <div className="card-footer">
        <div className="text-right">
          <button className="btn btn-secondary mr-3" onClick={() => onCancel(note)}>Cancel</button>
          <button className="btn btn-primary" onClick={() => onSave(note, content)}>Save</button>
        </div>
      </div>
    </div>;
  }
}

export {
  ViewNote,
  EditNote
};



/** WEBPACK FOOTER **
 ** ./src/main/js/notes/components/Note.js
 **/